<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="[getSelectedDEV && 'dev-selected-component']">
    <v-container fluid class="content-markdown" v-if="markdown" v-html="markdown"></v-container>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';

import { Remarkable } from 'remarkable';
import hljs from 'highlight.js';

export default {
  mixins: [abstractField, devComponentMixin],

  data() {
    return {
      markdown: ''
    };
  },

  created() {
    this.renderMarkdown(this.value);
  },

  methods: {
    renderMarkdown(template) {
      hljs.initHighlightingOnLoad();

      let md = new Remarkable({
        html: false,
        xhtmlOut: true,
        breaks: true,
        langPrefix: 'language-',
        linkTarget: '_blank',
        typographer: true,
        quotes: '“”‘’',

        highlight: function(str, lang) {
          if (lang && hljs.getLanguage(lang)) {
            try {
              return hljs.highlight(lang, str).value;
            } catch (__) {}
          }

          try {
            return hljs.highlightAuto(str).value;
          } catch (__) {}

          return '';
        }
      });

      this.markdown = md.render(template);
    }
  }
};
</script>
